/**
 * 翻译数据字典
 * @date: 2019年8月8日
 * @author: wdq
 * */

const computedArr = function (arr, value) {
  if (Object.prototype.toString.call(arr).slice(8, -1) !== 'Array') {
    return
  }
  for (let item of arr) {
    if (item.value === value) {
      return item.label
    }
  }
}

// initial state
const state = JSON.parse(localStorage.getItem("sysDic"))

// getters
const getters = {
  /**
   * 翻译单据状态名称
   * */
  getBillStatusName: ({applyStatus}) => (value) => computedArr(applyStatus, value),
  /**
   * 翻译招标类别
   * */
  getTenderClassifyName: ({tenderClassify}) => (value) => computedArr(tenderClassify, value),
  /**
   * 是否总包
   */
  getIsTotalPackName: ({isTotalPack}) => (value) => computedArr(isTotalPack, value),
  /**
   * 评标方法
   */
  getBidMethodName: ({bidMethod}) => (value) => computedArr(bidMethod, value),
  /**
   * 是否采用招标方式
   */
  getIsUseTenderMethodName: ({isUseTenderMethod}) => (value) => computedArr(isUseTenderMethod, value),
  /**
   * 资金样式
   */
  getSourceFundName: ({sourceFund}) => (value) => computedArr(sourceFund, value),
  /**
   * 招标样式
   */
  getTenderWayName: ({tenderWay}) => (value) => computedArr(tenderWay, value),
  /**
   * 招标组织形式
   */
  getTenderMethodName: ({tenderMethod}) => (value) => computedArr(tenderMethod, value),
  /**
   * 招标范围
   */
  getTenderAreaName: ({tenderArea}) => (value) => computedArr(tenderArea, value),
  /**
   * 变更审批：工程变更类型
   */
  getChangeTypeName: ({changeType}) => (value) => computedArr(changeType, value),
  /**
   * 付款类型档案
   */
  getPaymentTypeDocName: ({paymentTypeDoc}) => (value) => computedArr(paymentTypeDoc, value),
  /**
   * 付款方式 定义合同中需引用到的付款方式
   */
  getPaymentMethodName: ({paymentMethod}) => (value) => computedArr(paymentMethod, value),
  /**
   * 成本合同 配置
   */
  getCostContractConfigName: ({costContractConfig}) => (value) => computedArr(costContractConfig, value),
  /**
   * 任务状态
   */
  getTaskStatusName: ({taskStatus}) => (value) => computedArr(taskStatus, value),
  /**
   * 树状下级
   */
  getIsChildrenName: ({isChildren}) => (value) => computedArr(isChildren, value),
  /**
   * 登录状态
   */
  getLonginStatusName: ({longinStatus}) => (value) => computedArr(longinStatus, value),
  /**
   * 操作提示
   */
  getPromptsName: ({prompts}) => (value) => computedArr(prompts, value),
  /**
   * 启用状态
   */
  getEnabledName: ({enabled}) => (value) => computedArr(enabled, value),
  /**
   * 项目级别
   */
  getProjectLevelName: ({projectLevel}) => (value) => computedArr(projectLevel, value),
  /**
   * 工程类型
   */
  getEngineTypeName: ({engineType}) => (value) => computedArr(engineType, value),
  /**
   * 项目类型
   */
  getProjectTypeName: ({projectType}) => (value) => computedArr(projectType, value),
  /**
   * 项目资金属性
   */
  getProjectFundName: ({projectFund}) => (value) => computedArr(projectFund, value),
  /**
   * 立项类型
   */
  getTopicTypeName: ({topicType}) => (value) => computedArr(topicType, value),
  /**
   * 建设性质
   */
  getBuildPropName: ({buildProp}) => (value) => computedArr(buildProp, value),
  /**
   * 项目阶段
   */
  getprojectPhasesName: ({projectPhases}) => (value) => computedArr(projectPhases, value),
}



export default {
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/sysDic.js